'use strict';//Indicating browser should run only in java script mode

angular.module('EMR.Home').service('MessagesCommonService', ['$http', 'CommonService', function ($http, CommonService) {

	// ########################################################   GET ALL UNREAD COUNTS RELATED TO MESSAGES FOLDERS BLOCK - START ########################################################
	/// PURPOSE: THIS METHOD IS USED TO GET ALL UNREAD COUNTS RELATED TO MESSAGES FOLDERS
	/// CREATED BY: AKBAR
	/// CREATED ON: 05/16/2019
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
	this.MessagesServiceGetMessagesUnReadCount = function (postData) {
		postData.practicemodel = EMRPracticeModel;

		//SPECIFYING THAT IT IS A ACTION WCF CALL
		//postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST; // CURSOR LOADING WHILE GETTING DATA

		return CommonService.PostData('POST', CommonService.EHR_Messages_Counts_API() + "GetMessagesUnReadCount", postData).then(function (result) { return result; });

	};

	// ########################################################   GET ALL UNREAD COUNTS RELATED TO MESSAGES FOLDERS BLOCK - END ########################################################

	// ########################################################   UPDATE MESSAGE FOLDER COUNT BLOCK - START ########################################################
	///*******PURPOSE:  THIS METHOD IS USED TO UPDATE MESSAGE FOLDER COUNT
	///*******CREATED BY: AKBAR
	///*******CREATED DATE: 05/16/2019
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************  
	this.MessagesServiceUpdateMessageFolderCount = function (postData, isFromSingleUpdate) {
		let apiEndPoint = ShowSingleThreadMessageForPractice() ? "UpdateMessageFolderCountSingleThread" : "UpdateMessageFolderCount";
		var timeout = 30 * 60 * 1000;

		if (hasValue(isFromSingleUpdate) && isFromSingleUpdate) {
			//SPECIFYING THAT IT IS A ACTION WCF CALL
			postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE; // CURSOR LOADING WHILE GETTING DATA
		}
		return CommonService.PostData('POST', CommonService.EHR_Messages_Counts_API() + apiEndPoint, postData, timeout, true).then(function (result) { return result; });
	};

	// ########################################################   UPDATE MESSAGE FOLDER COUNT BLOCK - END ########################################################

	//================================GET UPDATED INBOX PORTAL MESSAGES COUNT BLOCK START==================================
	/// *******PURPOSE:THIS IS USED  TO GET UPDATED INBOX PORTAL MESSAGES COUNT     
	///*******CREATED BY: A. G. K
	///*******CREATED DATE: 07/13/2017
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
	this.GetInboxUnreadMessagesCountSinceLastLogout = function (postData) {

		postData.practicemodel = EMRPracticeModel
		

		return CommonService.PostData('POST', CommonService.EHR_Messages_Counts_API() + "GetInboxUnreadMessagesCountSinceLastLogout", postData).then(function (result) { return result; });

	};
	//================================GET UPDATED INBOX PORTAL MESSAGES COUNT BLOCK END==================================

	//================================GET UPDATED INBOX USER MESSAGES COUNT BLOCK START==================================
	/// *******PURPOSE:THIS IS USED  TO GET UPDATED INBOX USER MESSAGES COUNT     
	///*******CREATED BY: A. G. K
	///*******CREATED DATE: 06/28/2017
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
	this.GetUpdatedInboxUserMessagesCount = function (postData) {

		postData.practicemodel = EMRPracticeModel

		return CommonService.PostData('POST', CommonService.EHR_Messages_Counts_API() + "GetUpdatedInboxUserMessagesCount", postData).then(function (result) { return result; });

	};
	//================================GET UPDATED INBOX USER MESSAGES COUNT BLOCK END==================================

	///*******PURPOSE:THIS IS USED TO GET PORTAL UNREAD MEASSAGES COUNT 
	///*******CREATED BY:RAMBABU    
	///*******CREATED DATE: 06/24/2015
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
	this.messagesMainViewGetPortalUnReadMessageCount = function (postData) {
		postData.practicemodel = EMRPracticeModel;

		//SPECIFYING THAT IT IS A ACTION WCF CALL
		//postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST; // CURSOR LOADING WHILE GETTING DATA

		return CommonService.PostData('POST', CommonService.EHR_Messages_Counts_API() + "GetPortalUnReadMessageCount", postData).then(function (result) { return result; });

	};

}]);